import { createSlice } from '@reduxjs/toolkit';

const vesselOverviewSlice = createSlice({
  name: 'vessel',
  initialState: {
    currentVessel: null,
    vessels: [],
    loading: false,
    error: null,
  },
  reducers: {
    setVessels: (state, action) => {
      state.vessels = action.payload;
      state.loading = false;
    },
    setCurrentVessel: (state, action) => {
      state.currentVessel = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    resetVesselState: (state) => {
      state.currentVessel = null;
      state.vessels = [];
      state.loading = false;
      state.error = null;
    },
  },
});

export const { 
  setVessels, 
  setCurrentVessel, 
  setLoading, 
  setError,
  resetVesselState 
} = vesselOverviewSlice.actions;
export default vesselOverviewSlice.reducer;